import { Param } from "./param";

export class DoubleParam extends Param {

  protected readonly PLACEHOLDER = "placeholder";

  get placeholder(): string { return this.getInternalValue<string>(this.PLACEHOLDER); }
  setPlaceholder(placeholder: string): this { return this.setInternalValue(this.PLACEHOLDER, placeholder); }

}